import { Col, Row } from 'react-bootstrap-v5'
import { Modal } from 'rsuite'

type Props = {
  data: {
    mobileNumber: string
    emailAddress: string
    amount: string
    guaranteeReferenceNumber: string
    // online verification fields: present only when the backend setting showBankGuaranteeVerification is on
    type?: string | null
    typeLabel?: string | null
    requestId?: string | null
    status?: string | null
    validity?: string | null
    verifiedAt?: string | null
    createdAt?: string | null
    bgExpiryDate?: string | null
    bcReferenceNumber?: string | null
    bcSerialNumber?: string | null
    bcAmount?: string | null
    bcCurrency?: string | null
    bcPrintDate?: string | null
  }
  handleClose: () => void
}
const ViewDetailsModal = ({ handleClose, data }: Props) => {
  const isBc = data.type === 'balance_confirmation'
  const verificationRows: [string, any][] = data.type
    ? [
        ['Request ID', data.requestId],
        ['Verification Type', data.typeLabel],
        ...((isBc
          ? [
              ['Reference Number', data.bcReferenceNumber],
              ['Serial Number', data.bcSerialNumber],
              ['Converted Balance', data.bcAmount],
              ['Currency', data.bcCurrency],
              ['Print Date', data.bcPrintDate],
            ]
          : [['Expiry Date', data.bgExpiryDate]]) as [string, any][]),
        ['Status', data.status],
        ['Validity', data.validity],
        ['Verified At', data.verifiedAt],
        ['Requested At', data.createdAt],
      ]
    : []
  return (
    <div className='modal-container'>
      <Modal
        open={true}
        onClose={handleClose}
        className='w-75'
        backdrop='static'
        keyboard={false}
        enforceFocus={false}
        data-cy='modal'
      >
        <Modal.Header>
          <Modal.Title data-cy='modal-title'>Bank Guarantee Application Details </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Row>
              <Col md={6}>
                <b>Bank Guarantee Reference Number</b>
              </Col>
              <Col md={6}>
                <p>{data.guaranteeReferenceNumber}</p>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <b>Mobile Number</b>
              </Col>
              <Col md={6}>
                <p>{data.mobileNumber}</p>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <b>Email Address</b>
              </Col>
              <Col md={6}>
                <p>{data.emailAddress}</p>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <b>Amount</b>
              </Col>
              <Col md={6}>
                <p>{data.amount}</p>
              </Col>
            </Row>
            {verificationRows.map(([label, value]) => (
              <Row key={label}>
                <Col md={6}>
                  <b>{label}</b>
                </Col>
                <Col md={6}>
                  <p>{value || '-'}</p>
                </Col>
              </Row>
            ))}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}
export default ViewDetailsModal
